// removed by extract-text-webpack-plugin
module.exports = {"root":"_1rsOZVL","title":"_3CbnXR_","logo":"_3xK1scn","promoList":"KToQ_uI","promoListItem":"_2kMhNE4","courseList":"P0Gx0IA","courseListItem":"_1W0JDBt","courseListLink":"mKxYEgn","button":"_31cspjg"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/Lmis/DefaultLmis/DefaultLmis.less
 ** module id = 879
 ** module chunks = 0
 **/